import { Feedback } from '../models/feedbacks/feedback.ts';
import GenerateFeedbacksQuery from '../models/helpers/generateFeedbacksQuery.ts';
import { FeedbackSearchParam } from '../models/searchParams/feedbackSearchParam.ts';
import { TableSearchParam } from '../models/searchParams/tableSearchParam.ts';
import { ApiClient } from "./ApiClient.js";

const FeedbacksController = {
    get: (tableSearchParam: TableSearchParam, searchParam: FeedbackSearchParam) => {
        let url = `feedbacks/${tableSearchParam.offset}/${tableSearchParam.limit}${GenerateFeedbacksQuery(searchParam)}`;
        return ApiClient.get(url);
    },
    getByID: (id: number) => {
        return ApiClient.get(`feedback/${id}`);
    },
    post: (entity: Feedback) => {
        return ApiClient.post('feedback', entity);
    },
    put: (entity: Feedback) => {
        return ApiClient.put(`feedback/${entity.feedbackID}`, entity);
    },
    delete: (id: number) => {
        return ApiClient.delete(`feedback/${id}`)
    }
};
export default FeedbacksController;